import { RFIconProps } from "../types";

export default function MarkDownIcon(props: RFIconProps) {
	return (
		<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_3252_519)">
				<path
					d="M1.6333 1.58668L4.02263 5.04935L6.83197 1.57735L10.92 8.76402"
					stroke="currentColor"
					strokeWidth={props.strokeWidth || 1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.4375 8.95068L11.4895 9.56668L12.0775 6.58001"
					stroke="currentColor"
					strokeWidth={props.strokeWidth || 1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3252_519">
					<rect width="14" height="11.2" fill="white" transform="matrix(1 0 0 -1 0 11.2)" />
				</clipPath>
			</defs>
		</svg>
	);
}
